import { render, staticRenderFns } from "./QuestionComponent.vue?vue&type=template&id=2dcbc34c&scoped=true"
import script from "./QuestionComponent.vue?vue&type=script&lang=js"
export * from "./QuestionComponent.vue?vue&type=script&lang=js"
import style0 from "./QuestionComponent.vue?vue&type=style&index=0&id=2dcbc34c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcbc34c",
  null
  
)

export default component.exports